/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  GenericErrorResponse,
} from './responses';

import { ContentType, HttpClient, RequestParams } from './httpClient';
import { CookiePayload } from './requests';

export class Cookies<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Cookies
   * @name signOut
   * @request POST:/api/auth/cookie
   * @response `200` `ApiResponse` Success
   */
  set = (data: CookiePayload, params: RequestParams = {}) =>
    this.request<null, GenericErrorResponse>({
      path: `/api/auth/cookie`,
      method: 'POST',
      body: data,
      format: 'json',
      secure: true,
      ...params,
    });

  /**
   * No description
   *
   * @tags Cookies
   * @name socialSignIn
   * @request DELETE:/api/auth/cookie
   * @response `200` `ApiResponse` Success
   */
  delete = (name: string, params: RequestParams = {}) =>
    this.request<null, GenericErrorResponse>({
      path: `/api/auth/cookie/${name}`,
      method: 'DELETE',
      type: ContentType.Json,
      format: 'json',
      secure: true,
      ...params,
    });
}